import React, { useState, useEffect, useRef } from 'react';
import { Header } from '../../Components/Layout/Header.jsx';
import { MetaTags } from '../../Components/Layout/MetaTags.jsx';
import RiveComponent from "../../Components/Shared/RiveComponent";
import Flickity from 'flickity';
import 'flickity/dist/flickity.min.css';

export default function ZimskaSuperBomba(props) {
    //STATES
    const [flickityInstance, setFlickityInstance] = useState(null);
    const [initialBomb, setInitialBomb] = useState(null);

    // Reference to the Flickity element
    const flickityRef = useRef(null);

    // useEffect to initialize Flickity
    useEffect(() => {
        let now = new Date().toISOString();

        if (now >= "2025-01-06T00:00:00" && now <= "2025-01-12T23:59:00") {
            setInitialBomb(0);
        } else if (now >= "2025-01-13T00:00:00" && now <= "2025-01-19T23:59:00") {
            setInitialBomb(1);
        } else if (now >= "2025-01-20T00:00:00" && now <= "2025-01-26T23:59:00") {
            setInitialBomb(2);
        } else if (now >= "2025-01-27T00:00:00" && now <= "2025-02-05T23:59:00") {
            setInitialBomb(3);
        } else {
            setInitialBomb(null);
        }

        if (flickityRef.current) {
            const flickityOptions = {
                cellAlign: 'center',
                resize: true,
                contain: true,
                groupCells: 1,
                draggable: true,
                wrapAround: true,
                pageDots: false,
                initialIndex: initialBomb,
                prevNextButtons: false,
                selectedAttraction: 0.01,
                friction: 0.15,
            };

            const flkty = new Flickity(flickityRef.current, flickityOptions);
            setFlickityInstance(flkty);

            // Cleanup on unmount
            return () => {
                flkty.destroy();
            };
        }
    }, [initialBomb]);

    // Function to move to the next slide
    const nextSlide = () => {
        if (flickityInstance) {
            flickityInstance.next();
        }
    };

    // Function to move to the previous slide
    const previousSlide = () => {
        if (flickityInstance) {
            flickityInstance.previous();
        }
    };

    function ZimskaSuperBombaBanner() {
        const [state, setState] = useState({
            days: '00',
            hours: '00',
            minutes: '00',
            seconds: '00',
            promotionFinished: false
        });
        const [promotionText, setPromotionText] = useState('Trajanje promocije');
        const [aktivnoOd, setAktivnoOd] = useState('2025-01-06T00:00:00');
        const [aktivnoDo, setAktivnoDo] = useState('2025-02-05T23:59:00');

        useEffect(() => {
            var startDateTime = new Date(aktivnoOd);
            var endDateTime = new Date(aktivnoDo);

            if (new Date() < startDateTime) {
                setPromotionText("Do promocije");
                startBannerCountDownTime(startDateTime);
            } else {
                startBannerCountDownTime(endDateTime);
            }

        }, []);

        function startBannerCountDownTime(endDateTime) {
            // Get todays date and time
            var now = new Date().getTime();
            // Find the distance between now an the count down date
            var distance = endDateTime - now;

            // Time calculations for days, hours, minutes and seconds
            var days = ('0' + Math.floor(distance / (1000 * 60 * 60 * 24))).slice(-2);
            var hours = ('0' + Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60))).slice(-2);
            var minutes = ('0' + Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60))).slice(-2);
            var seconds = ('0' + Math.floor((distance % (1000 * 60)) / 1000)).slice(-2);

            setState({ ...state, days: days, hours: hours, minutes: minutes, seconds: seconds });

            // If the count down is finished, write some text
            if (distance < 0) {
                setState({ ...state, days: '00', hours: '00', minutes: '00', seconds: '00' });
                if (new Date() > new Date(aktivnoOd) && new Date() < new Date(aktivnoDo)) {
                    setPromotionText("Trajanje promocije");
                    startBannerCountDownTime(new Date(aktivnoDo));
                } else {
                    setState({ ...state, promotionFinished: true });
                }
            } else {
                setTimeout(() => startBannerCountDownTime(endDateTime), 1000);
            }
        }


        function isPromotionStarted() {
            return new Date().getTime() > new Date(aktivnoOd).getTime();
        };

        return (
            <div className="mjesecna-superbomba-banner2">
                <section className="mjesecna-superbomba2 banner--inner selected">
                    <div className="banner--content">
                        <div className="banner--bg-container">
                            <div className="banner--repeater" />
                            <div className="banner--repeater2">
                            </div>
                            <div className="banner--background" />
                        </div>
                        <div className="banner--foreground">
                            <div className="rive-container">
                                <RiveComponent
                                    lazyLoad={true}
                                    cacheBust={`c=${casino.config.guiCacheVerzija}`}
                                    src={`${casino.config.casinoCDNImagesUrl}/Banners/SijecanjskaSuperBomba/sijecanjska_sb_egtd_01-2025-web.riv`}
                                    stateMachines="State Machine 1"
                                    useOffscreenRenderer={true}
                                    playRequest={true}
                                    disablePlayOutsideViewport={{ rootMargin: "-50px 0px 0px 0px", threshold: 0.25 }}
                                />
                            </div>
                            <div className="banner--image"></div>
                            <div className="platform"></div>
                            <div className="counter-container">
                                {!state.promotionFinished && <div className="content casino-superskok">
                                    <div className="text">{promotionText}</div>
                                    <div className="counter">
                                        <div className="number">
                                            <div className="text-number">{state.days}</div>
                                            <div className="text-footer">Dana</div>
                                        </div>

                                        <div className="number">
                                            <div className="text-number">{state.hours}</div>
                                            <div className="text-footer">Sati</div>
                                        </div>

                                        <div className="number">
                                            <div className="text-number">{state.minutes}</div>
                                            <div className="text-footer">Min</div>
                                        </div>

                                        <div className="number">
                                            <div className="text-number">{state.seconds}</div>
                                            <div className="text-footer">Sek</div>
                                        </div>
                                    </div>
                                </div>
                                }
                                {state.promotionFinished &&
                                    <div className="content-zavrsetak">
                                        Promocija je završila
                                    </div>
                                }
                            </div>
                        </div>
                    </div>
                </section>
            </div>
        )
    }

    function renderBombsContainer() {

        const bombs = [
            {
                bombName: "first-week",
                reward: "30.000 €",
                activeFrom: "2025-01-06T00:00:00",
                activeTo: "2025-01-12T23:59:00",
                backgroundColor: "linear-gradient(160.74deg, #EFD261 1.8%, #E99300 96.84%)",
                buttonColor: "#EAA506",
                link: "https://mcasino.supersport.hr/promotions/casino-superbomba/egt-digital-2025-01-1"
            },
            {
                bombName: "second-week",
                reward: "40.000 €",
                activeFrom: "2025-01-13T00:00:00",
                activeTo: "2025-01-19T23:59:00",
                backgroundColor: "linear-gradient(281.95deg, #2C61A8 0%, #6A96ED 100%)",
                buttonColor: "#2F63AB",
                link: "https://mcasino.supersport.hr/promotions/casino-superbomba/egt-digital-2025-01-2"
            },
            {
                bombName: "third-week",
                reward: "50.000 €",
                activeFrom: "2025-01-20T00:00:00",
                activeTo: "2025-01-26T23:59:00",
                backgroundColor: "linear-gradient(158.73deg, #FF7738 0%, #B43A01 100%)",
                buttonColor: "#BF420A",
                link: "https://mcasino.supersport.hr/promotions/casino-superbomba/egt-digital-2025-01-3"
            },
            {
                bombName: "forth-week",
                reward: "80.000 €",
                activeFrom: "2025-01-27T00:00:00",
                activeTo: "2025-02-05T23:59:00",
                backgroundColor: "linear-gradient(283.02deg, #007284 0%, #4D9EA9 98.87%)",
                buttonColor: "#037485",
                link: "https://mcasino.supersport.hr/promotions/casino-superbomba/egt-digital-2025-01-4"
            },
        ];

        function renderBomb(bombName, reward, activeFrom, activeTo, backgroundColor, buttonColor, link) {
            const [bombStarted, setBombStarted] = useState(false);
            const [bombFinished, setBombFinished] = useState(false);

            useEffect(() => {
                let now = new Date().getTime();
                let activeFromTime = new Date(activeFrom).getTime();
                let activeToTime = new Date(activeTo).getTime();

                setBombStarted(now >= activeFromTime);
                setBombFinished(now > activeToTime);
            }, []);

            return (
                <div key={bombName} className={"bomb " + bombName} style={{ background: backgroundColor }}>
                    <div className={"bomb-status " + (bombStarted && !bombFinished ? "green" : "grey")}>
                        {!bombStarted && !bombFinished && <div className="message">USKORO</div>}
                        {bombStarted && !bombFinished && <div className="message"><span className="active"></span>AKTIVNO</div>}
                        {bombStarted && bombFinished && <div className="message"><span className="finished"></span>ZAVRŠENO</div>}
                    </div>
                    <div className={"bomb-title " + bombName}>
                        {bombName === "no-limit-city" && <div className="rive-container">
                            <RiveComponent
                                lazyLoad={true}
                                cacheBust={`c=${casino.config.guiCacheVerzija}`}
                                src="Content/Images/Promotions/ZimskaSuperBomba/zimska_sb_evolution_v2.riv"
                                stateMachines="State Machine 1"
                                width="400"
                                height="200"
                                useOffscreenRenderer={true}
                                playRequest={true}
                                disablePlayOutsideViewport={{ target: ".bomb-title", rootMargin: "-50px 0px 0px 0px", threshold: 0.25 }}
                            />
                        </div>}
                    </div>
                    <div className="bomb-reward">{reward}</div>
                    <div className={`bomb-image ${(!bombStarted && !bombFinished) ? "bomb-soon" : ""} ${(bombStarted && !bombFinished) ? "bomb-active" : ""} ${(bombStarted && bombFinished) ? "bomb-end" : ""}`}>
                    </div>
                    {!bombFinished &&
                        <div className="bomb-time-period">
                            <p className="lasts">Traje:</p>
                            <p className="lasts-from-to">
                                Od {new Date(activeFrom).toLocaleDateString('hr-HR', { day: '2-digit', month: 'numeric' })} do {new Date(activeTo).toLocaleDateString('hr-HR', { day: '2-digit', month: 'numeric' })}
                            </p>
                        </div>
                    }
                    <div
                        className="bomb-button"
                        style={{
                            color: buttonColor,
                            marginTop: bombFinished ? '5rem' : '0rem',
                        }}
                        onClick={() => window.location = link}
                    >
                        {bombStarted && !bombFinished &&
                            <div className="play-button">
                                <svg style={{ marginRight: '8%', fill: buttonColor }} width="18" height="14" viewBox="0 0 18 14" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M9.44221 13.6233C9.18539 13.3722 9.06212 13.0688 9.07239 12.713C9.08352 12.3572 9.2175 12.0538 9.47432 11.8027L13.1019 8.2556H1.78411C1.42028 8.2556 1.11509 8.13507 0.86854 7.89399C0.622847 7.65375 0.5 7.35575 0.5 7C0.5 6.64424 0.622847 6.34583 0.86854 6.10475C1.11509 5.86451 1.42028 5.74439 1.78411 5.74439H13.1019L9.44221 2.16592C9.18539 1.9148 9.05698 1.61638 9.05698 1.27067C9.05698 0.925799 9.18539 0.627802 9.44221 0.376681C9.69904 0.12556 10.0042 0 10.3578 0C10.7105 0 11.0152 0.12556 11.2721 0.376681L17.1469 6.12108C17.2753 6.24664 17.3665 6.38266 17.4204 6.52915C17.4735 6.67563 17.5 6.83259 17.5 7C17.5 7.16741 17.4735 7.32436 17.4204 7.47085C17.3665 7.61734 17.2753 7.75336 17.1469 7.87892L11.24 13.6547C11.0045 13.8849 10.7105 14 10.3578 14C10.0042 14 9.69904 13.8744 9.44221 13.6233Z" />
                                </svg>
                                ZAIGRAJ
                            </div>
                        }
                        {bombStarted && bombFinished && <div className="reward-button"><span className="coin"></span>NAGRADE</div>}
                        {!bombFinished && !bombStarted && <div className="find-out-more-button">SAZNAJ VIŠE</div>}
                    </div>
                </div>
            )
        };

        return (
            <div className="bombs-wrapper">
                <div className="bombs-container" ref={flickityRef}>
                    {bombs.map((bomb, index) => renderBomb(bomb.bombName, bomb.reward, bomb.activeFrom, bomb.activeTo, bomb.backgroundColor, bomb.buttonColor, bomb.link))}
                </div>
            </div>
        )
    }

    function renderHowContainer() {
        return (
            <div className="how-container">
                <h1>Kako sudjelovati?</h1>
                <p>Tijekom SuperBombe nagrade dijelimo nasumično, a ti moraš samo slijediti ove korake:</p>
                <div className="explain-container">
                    <div className="section">
                        <div className="play-logo"></div>
                        <div className="text-container">
                            <h2>ZAIGRAJ</h2>
                            <p>Igraj igre <strong>EGT Digital</strong> providera uz minimalni ulog po vrtnji od <strong>0,20 €</strong>.</p>
                        </div>
                    </div>
                    <hr />
                    <div className="section">
                        <div className="bomb-logo"></div>
                        <div className="text-container">
                            <h2>AKTIVIRAJ</h2>
                            <p>Kad ti se tijekom igre na ekranu pojavi bomba, aktiviraj je i otkrit ćeš svoju nagradu.</p>
                        </div>
                    </div>
                    <hr />
                    <div className="section">
                        <div className="bag-logo"></div>
                        <div className="text-container">
                            <h2>OSVOJI</h2>
                            <p>Nagradu ćemo ti odmah isplatiti na račun, a nakon toga možeš nastaviti uživati u igri.</p>
                        </div>
                    </div>
                </div>
            </div>
        )
    }

    function renderBottomContainer() {
        return (
            <div className="bottom-container">
                <h1>Eksplozivno startaj u novu godinu</h1>
                <p className="paragraph bold">Uključi se u SuperBombe EGT Digital providera 💣 jer dijelimo 200.000 €.</p>
                <p className="paragraph">Tijekom siječnja pripremili smo čak 4 uzbudljive SuperBombe sa spektakularnim nagradnim fondom.</p>
                <p className="paragraph">Podsjećamo, u SuperBomba promocijama nema natjecanja, bodovanja niti rang-listi. Nagrade se dodjeljuju slučajnim odabirom i svaki igrač koji ispunjava uvjete sudjelovanja ima jednaku šansu za osvajanje.</p>
                <p className="paragraph">Zato nemoj dopustiti da netko drugi pokupi super nagradu ispred tvog nosa.</p>
                <p className="paragraph">Priprema, pozor, zaigraj! 💥</p>
                <div className="bottom-image"></div>
            </div>
        )
    }

    return (
        <>
            <MetaTags title="Siječanjska SuperBomba | SuperSport | SuperCasino" description="Siječanjska SuperBomba SuperSport Casino!" />

            <Header key="header" {...props} />
            <div className="white-background">
                {ZimskaSuperBombaBanner()}

                <div id="mjesecna-superbomba-page-wrapper">
                    <div className="mjesecna-superbomba-page">
                        <h1>Sve siječanjske SuperBombe</h1>
                        <p>Sudjeluj u EGT Digital SuperBombama tijekom siječnja i osvoji vrijedne nagrade.</p>

                        {renderBombsContainer()}

                        <hr />

                        {renderHowContainer()}

                        <hr />

                        {renderBottomContainer()}
                    </div>
                </div>

            </div>
        </>
    );
};